import CabinetShell from '../../features/cabinet/CabinetShell';
import { CHAT_OPERATOR_CABINET } from '../../features/cabinet/configs';

export default function ChatOperatorPage() {
  return <CabinetShell config={CHAT_OPERATOR_CABINET} />;
}
